/**
 * The body for POST /staffmember/disable that flips a staff member's access.
 *
 * Only `id` and `disabled`. The record read from GET /staffmember/get/{id} used to go back whole,
 * presence included, and its `lastActive` ("2026-10-30 13:17:32") is a format the write endpoints
 * could not parse, so disabling anyone who had been online failed with a 400 (KIN-2167). Presence
 * is the backend's to write, from the heartbeat, and since KIN-1724 a field the request leaves out
 * is kept, so nothing else needs to travel (KIN-2168).
 */
export const toAccessToggle = (current) => ({
  id: current.id,
  disabled: !current.disabled,
});
